import TabPage from "./../factories/tab-page";
import "./../bindings/bao-tabs";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as $ from "jquery";
import "./../components/view-models/bao-color-picker";
class Workplace extends BaseViewModel {

    constructor(tabPage: TabPage) {
        super(tabPage);
    }

    ShiftTypeColors: KnockoutObservableArray<string> = ko.observableArray([]);
    ColorString: KnockoutObservable<string> = ko.observable();
    Name: KnockoutObservable<string> = ko.observable();
    Description: KnockoutObservable<string> = ko.observable();
    InitUrl(): string {
        return 'Workplace/Init';
    }
    ;
    init() {
        return $.when(super.init(),this.loadShiftColors(), super.InitTabController()).then(() => {
            const tabQualifications = new TabPage('WorkplaceQualification');
            tabQualifications.IsClosable(false);
            tabQualifications.Url('WorkplaceQualification');
            tabQualifications.AutoSelect = true;
            this.TabController.AddTab(tabQualifications);
        });
    }
    CompleteCheck() {
        let isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.Name())) {
            isComplete = false;
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }

    loadShiftColors() {
        return Bao.post("ShiftType/GetShiftTypeColors")
            .then(result => {
                //ko.map.fromJS(result, this); this maps also properties to observables
                //this.Months = result.ShiftScheduleCalendar.map(v => v.Month).filter( (v, i, a) => a.indexOf(v) === i );
                this.ShiftTypeColors(result.ShiftTypeColors);
            });
    }
}
export default Workplace;